import NavigationBar from "../../../navigation/nav-bar/navigationBar";
import FooterComponent from "../../../navigation/footer/footerComponent";
import SecondaryIntensiveBody from "./secondaryIntensiveBody";

export default function MainSecondaryIntensive() {

    return (
        <div>
            <NavigationBar />
            <SecondaryIntensiveBody />
            <FooterComponent />
        </div>
    )
}